<ng-content select="[before]"></ng-content>

<color-presets-component 
    [columns]="7"
    direction="down"
    [(color)]="control.value" 
    [colorPresets]="control.presets" />

@if(childControl.presets.length) {
    <color-presets-component
        class="child-list"
        [columns]="7"
        direction="down"
        [(color)]="childControl.value" 
        [colorPresets]="childControl.presets" />
}

<ng-content></ng-content>